const namespaced = true

const state = {
  itemsPerPage: 100,
  recentList: undefined,
  recentPage: 1,
  favoriteList: undefined,
  favoritePage: 1
}

const mutations = {
  RESET (state) {
    state.itemsPerPage = 100
    state.recentList = undefined
    state.recentPage = 1
    state.favoriteList = undefined
    state.favoritePage = 1
  },
  SET_RECENT_LIST (state, payload) {
    state.recentList = payload
  },
  MERGE_RECENT_LIST (state, payload) {
    state.recentList = state.recentList.concat(payload)
  },
  SET_RECENT_PAGE (state, payload) {
    state.recentPage = payload
  },
  SET_FAVORITE_LIST (state, payload) {
    state.favoriteList = payload
  },
  MERGE_FAVORITE_LIST (state, payload) {
    state.favoriteList = state.favoriteList.concat(payload)
  },
  SET_FAVORITE_PAGE (state, payload) {
    state.favoritePage = payload
  }
}

const actions = {
  reset ({ commit }) {
    commit('RESET')
  },
  setRecentList ({ commit }, value) {
    commit('SET_RECENT_LIST', value)
  },
  mergeRecentList ({ commit }, value) {
    commit('MERGE_RECENT_LIST', value)
  },
  setRecentPage ({ commit }, value) {
    commit('SET_RECENT_PAGE', value)
  },
  setFavoriteList ({ commit }, value) {
    commit('SET_FAVORITE_LIST', value)
  },
  mergeFavoriteList ({ commit }, value) {
    commit('MERGE_FAVORITE_LIST', value)
  },
  setFavoritePage ({ commit }, value) {
    commit('SET_FAVORITE_PAGE', value)
  }
}

const getters = {
  getItemsPerPage: (state) => state.itemsPerPage,
  getRecentList: (state) => state.recentList,
  getRecentPage: (state) => state.recentPage,
  getFavoriteList: (state) => state.favoriteList,
  getFavoritePage: (state) => state.favoritePage
}

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/myPlace.js